import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Switch, TextField } from "@mui/material";
import MaterialTable, { MTableAction } from "material-table";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";

import SelectableSearch from "../../../Base/views/SelectableSearch";
import { GetEmployeesAction } from "../../../../../store/Employee/Employee/Action";
import {
  AddExpenseSubtypeAction,
  AddExpenseTypeAction,
  DeleteExpenseSubtypeAction,
  DeleteExpenseTypeAction,
  GetExpenseSubtypeAction,
  GetExpenseTypeAction,
  UpdateExpenseSubtypeAction,
  UpdateExpenseTypeAction,
} from "../../../../../store/Finance/Expense/Action";
import { toast } from "react-toastify";
import SearchCreatable from "../../../ExpenseManagement/helper/HelperComponents/SearchCreatable";
import SelectableEditableFilter from "../../../Base/views/SelectableEditableFilter";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";

const ExpenseTypeGrid = () => {
  const dispatch = useDispatch();
  const { expense_types, expense_subtypes, expenseSubtypeLoading } =
    useSelector((state) => state?.FinanceReducer?.ExpenseReducer);

  const structureData = (expense_subtypes || [])?.map((item) => ({
    ...item,
    expense_type_id: {
      expense_type_id: item?.expense_type_id,
      expense_type_name: item?.expense_type_name,
    },
    approver_executive_employee_fk: {
      employee_id: item?.approver_executive_employee_fk,
      name: item?.approver_name,
    },
  }));
  const { employees_options } = useSelector(
    (state) => state.EmployeeReducer.EmployeesReducer
  );
  const [selected, setSelected] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [deletedItem, setDeletedItem] = useState({});
  const [employeesData, setEmployeesData] = useState({
    load: true,
    values: [],
  });
  const [subTypeData, setSubTypeData] = useState({
    load: true,
    values: [],
  });
  const handleSubType = () => {
    expense_types && setSubTypeData({ load: false, values: expense_types });
  };
  const handleEmployees = () => {
    employees_options &&
      setEmployeesData({
        load: false,
        values: employees_options?.filter(
          (el) =>
            el?.enable_expense_executive ||
            el?.core_hr_user_type === "Owner" ||
            el?.core_hr_user_type === "Admin"
        ),
      });
  };
  useEffect(() => {
    dispatch(GetExpenseTypeAction());
    dispatch(GetEmployeesAction({ is_active: true }));
  }, [dispatch]);

  const handleAddExpenseType = (event, value) => {
    return new Promise((resolve, reject) => {
      dispatch(
        AddExpenseTypeAction(
          {
            expense_type_name: value?.expense_type_name,
          },
          (error, result) => {
            if (!error && result?.data?.statuscode === 200) {
              const newData = result?.data?.data;
              setSubTypeData({ load: false, values: newData });

              const resVal = newData.find(
                (res) => res?.expense_type_name === value?.expense_type_name
              );
              resolve(resVal);
            } else {
              toast.error("Something went wrong");
              reject(error);
            }
          }
        )
      );
    });
  };
  useEffect(() => {
    if (expense_types?.length > 0) {
      setSubTypeData({ load: false, values: expense_types });
    }
  }, [expense_types]);

  const handleEdit = (updatedItem) => {
    dispatch(UpdateExpenseTypeAction({
      expense_type_id: updatedItem?.expense_type_id,
      expense_type_name: updatedItem?.expense_type_name,
      proof_approval_required: updatedItem?.proof_approval_required,
    }))
  };
  
  const handleDelete = (deletedItem) => {
    setOpenDialog(true);
    setDeletedItem(deletedItem)    
  };
  const handleSubmitDelete = () => {
    dispatch(
      DeleteExpenseTypeAction({
        expense_type_id: `{${deletedItem?.expense_type_id}}`,
      },
        (error, result) => {
          if (!error && result?.data?.statuscode === 200) {
            if(selected?.expense_type_id === deletedItem?.expense_type_id) {
              setSelected("");
            }
            setOpenDialog(false);
            setDeletedItem({})
            const filterSubType = expense_subtypes?.filter((el => el.expense_type_id === deletedItem?.expense_type_id))
            if (filterSubType?.length > 0) {
              dispatch(
                       DeleteExpenseSubtypeAction({
                         sub_expense_type_id: `{${filterSubType?.map(item => item.sub_expense_type_id).join(",")}}`
                       })
                     );
            }
          } else {
            toast.dismiss();
            toast.error("Something went wrong");
          }
        }
      )
    );
  }

  useEffect(()=> {
    dispatch(GetExpenseSubtypeAction({
      expense_type_id: selected?.expense_type_id ? `{${selected?.expense_type_id}}` : null
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selected, expense_types])

  const titleContent = <Box pt={1.5} pb={2} sx={{ minWidth: 250}}>
      <SelectableEditableFilter 
       label="Expense Type"
        optionData={expense_types}
        name={"expense_type_id"}
        fieldLabel="expense_type_name"
        value={selected}
        onChange={(val) => setSelected(val)}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
  </Box>
return (
    <Box>
      <MaterialTable
        isLoading={expenseSubtypeLoading}
        columns={[
          {
            title: "Expense Type",
            headerStyle: { textAlign: "start", paddingLeft: "2%" },
            cellStyle: { textAlign: "start", padding: "10px 0px 0px 2%" },
            field: "expense_type_id",
            grouping: false,
            validate: (rowData) => {
              if (
                rowData?.tableData &&
                rowData?.tableData?.editing === "delete"
              ) {
                return "";
              }
              if (!rowData?.expense_type_id) {
                return "Expense Type cannot be empty";
              }
              return "";
            },
            render: (rowData) =>
              rowData?.expense_type_id?.expense_type_name || "",
            editComponent: (props) => {
              const isEdit = props.rowData?.tableData?.editing === "update";
              return (
                <Box sx={{ width: "95%" }}>
                  <SearchCreatable
                    isOptionEqualToValue={(option, value) =>
                      +option.expense_type_id === +value.expense_type_id
                    }
                    fullWidth
                    disabled={isEdit}
                    required
                    variantType="standard"
                    size="small"
                    loading={() => handleSubType()}
                    value={props.value || ""}
                    fieldLabel="expense_type_name"
                    name="expense_type_id"
                    onChangeEvent={async (e, v) => {
                      if (v?.expense_type_id) {
                        props.onChange(v);
                      } else if (v?.expense_type_name) {
                        const newExp = await handleAddExpenseType(e, v);
                        props.onChange(newExp);
                      } else {
                        props.onChange(v);
                      }
                    }}
                    data={subTypeData}
                    showAddOption={true}
                    OptionName="Type to add new Expense Type"
                  />
                </Box>
              );
            },
          },
          {
            title: "Subtype",
            cellStyle: { padding: "10px 10px 0px 28px" },
            field: "sub_expense_type_name",
            validate: (rowData) => {
              if (
                rowData?.tableData &&
                rowData?.tableData?.editing === "delete"
              ) {
                return "";
              }
              if (!rowData?.sub_expense_type_name?.trim()) {
                return "Type cannot be empty";
              }
              return "";
            },
            editComponent: (props) => {
              return (
                <Box sx={{ width: "95%" }}>
                  <TextField
                    required={true}
                    variant="standard"
                    fullWidth
                    value={props?.value}
                    onChange={(e) => props.onChange(e.target.value)}
                  />
                </Box>
              );
            },
          },
          {
            title: "Approval Required",
            field: "proof_approval_required",
            headerStyle: { textAlign: "start", paddingLeft: "2%" },
            cellStyle: { textAlign: "start", padding: "10px 5px 0px 3%" },
            render: (rowData) => (
              <Box sx={{ pointerEvents: "none", opacity: 1 }}>
                <Switch
                  checked={!!rowData?.proof_approval_required}
                  color="primary"
                  size="medium"
                />
              </Box>
            ),
            editComponent: (props) => (
              <Switch
                checked={!!props.value}
                onChange={(e) => {
                  const newValue = e.target.checked;
                  props.onChange(newValue);
                  props.onRowDataChange({
                    ...props.rowData,
                    proof_approval_required: newValue,
                    approver_executive_employee_fk: "",
                  });
                }}
                color="primary"
                size="medium"
              />
            ),
          },
          {
            title: "Finance Approver",
            headerStyle: { textAlign: "start", paddingLeft: "2%" },
            cellStyle: { textAlign: "start", padding: "10px 0px 0px 2%" },
            field: "approver_executive_employee_fk",
            grouping: false,
            validate: (rowData) => {
              if (
                rowData?.tableData &&
                rowData?.tableData?.editing === "delete"
              ) {
                return "";
              }
              if (
                !rowData?.approver_executive_employee_fk &&
                rowData?.proof_approval_required
              ) {
                return "Finance Approver cannot be empty";
              }
              return "";
            },
            render: (rowData) =>
              rowData.approver_executive_employee_fk?.name || "N/R",
            editComponent: (props) => {
              return props?.rowData?.proof_approval_required ? (
                <Box sx={{ width: "95%" }}>
                  <SelectableSearch
                    fullWidth
                    required
                    variantType="standard"
                    size="small"
                    loading={handleEmployees}
                    value={props.value || ""}
                    fieldLabel="name"
                    name="employee_id"
                    onChangeEvent={(e, v) => {
                      props.onChange(v);
                    }}
                    data={employeesData}
                  />
                </Box>
              ) : (
                <Box></Box>
              );
            },
          },
        ]}
        data={structureData || []}
        icons={{
          Add: () => (
            <Button
              variant="contained"
              className="mpl-primary-btn"
              style={{
                minWidth: 0,
                width: "82px",
                height: "35px",
                padding: "2px 12px",
                textTransform: "none",
              }}
              startIcon={<AddIcon />}
            >
              Add
            </Button>
          ),
          Edit: () => <EditIcon sx={{ color: "#637381" }} />,
          Delete: () => <DeleteIcon sx={{ color: "#637381" }} />,
        }}
        editable={{
          onRowAdd: (newRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.expense_type_id) {
                return reject();
              }
              if (!newRow?.sub_expense_type_name?.trim()) {
                return reject();
              }
              if (
                !newRow?.approver_executive_employee_fk?.employee_id &&
                newRow?.proof_approval_required
              ) {
                return reject();
              }
              dispatch(
                AddExpenseSubtypeAction({
                  ...newRow,
                })
              );
              setTimeout(() => resolve(), 500);
            }),
          onRowUpdate: (newRow, oldRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.expense_type_id) {
                return reject();
              }
              if (!newRow?.sub_expense_type_name?.trim()) {
                return reject();
              }
              if (
                !newRow?.approver_executive_employee_fk?.employee_id &&
                newRow?.proof_approval_required
              ) {
                return reject();
              }
              dispatch(
                UpdateExpenseSubtypeAction({
                  ...newRow,
                })
              );
              setTimeout(() => resolve(), 500);
            }),
          onRowDelete: (selectedRow) =>
            new Promise((resolve, reject) => {
              dispatch(
                DeleteExpenseSubtypeAction({
                  ...selectedRow,
                  sub_expense_type_id: `{${selectedRow?.sub_expense_type_id}}`,
                })
              );
              setTimeout(() => resolve(), 1000);
            }),
        }}
        options={{
          maxBodyHeight: "250px",
          minBodyHeight: "250px",
          rowStyle: { fontSize: "13px" },
          headerStyle: { padding: "5px 10px 5px 25px", fontWeight: "bold" },
          sorting: false,
          search: false,
          searchFieldAlignment: "right",
          searchAutoFocus: true,
          searchFieldVariant: "standard",
          filtering: false,
          paging: false,
          selection: false,
          actionsColumnIndex: -1,
          grouping: false,
          addRowPosition: "first",
        }}
        components={{
          Action: (props) => {
            const ActionComponent = props?.components?.Action || MTableAction;

            if (
              props?.action?.icon &&
              typeof props?.action?.icon === "function"
            ) {
              return (
                <Box
                  sx={{
                    "& .MuiIconButton-root": {
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    },
                  }}
                >
                  <ActionComponent {...props} />
                </Box>
              );
            }
            return <ActionComponent {...props} />;
          },
        }}
        title={titleContent}
      />
      <ConfirmationDialog
          title="Do you wish to proceed?" // Are you sure you want to delete this expense type?
          content={<Box fontWeight={"500"}>
          All subtypes under <Box as="span" fontWeight="bold" display="inline">
            {deletedItem?.expense_type_name}
          </Box>{" "} expense type will also be permanently deleted.
          </Box>}
          openDialog={openDialog}
          closeDialog={setOpenDialog}
          OkButtonText="Yes"
          onSubmit={handleSubmitDelete}
      />
    </Box>
  );
};

export default ExpenseTypeGrid;
